import React, { createContext, forwardRef, createElement } from 'react';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

var HeadingContext = createContext({
  level: 0,
  title: ''
});
var H = forwardRef(function (props, ref) {
  return React.createElement(HeadingContext.Consumer, null, function (_ref) {
    var title = _ref.title,
        level = _ref.level;

    if (!level || isNaN(level)) {
      return null;
    }

    var tagProps = _objectSpread({
      ref: ref,
      children: title
    }, props);

    return createElement("h".concat(Math.min(level, 6)), tagProps);
  });
});
H.displayName = 'DocumentOutlineSectionH';

var DocumentOutlineSection = function DocumentOutlineSection(_ref2) {
  var title = _ref2.title,
      children = _ref2.children;
  return React.createElement(HeadingContext.Consumer, null, function (headingContext) {
    return React.createElement(HeadingContext.Provider, {
      value: {
        title: title,
        level: headingContext.level + 1
      }
    }, children || null);
  });
};

export { DocumentOutlineSection, H };